import { render, staticRenderFns } from "./ChangeForgotPwd.vue?vue&type=template&id=ea3f6fa8&"
import script from "./ChangeForgotPwd.vue?vue&type=script&lang=js&"
export * from "./ChangeForgotPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChangeForgotPwd.vue"
export default component.exports